import styled from "@emotion/styled";
import * as React from "react";

import { Button, DesignToken, Heading, SpacingToken, Text } from "@livechat/design-system-react-components";

import { ResponsiveBreakpoint } from "constants/responsive-breakpoint";
import { withVar } from "themes/helpers";

interface IProps {
  onCtaClick(): void;
}

export const SubscriptionPlansEnterprise: React.FC<IProps> = ({ onCtaClick }) => (
  <Container>
    <Heading size="sm">Expert guidance and premium services to help you manage your business at scale.</Heading>
    <Text
      size="sm"
      customColor={withVar(DesignToken.ContentBasicSecondary)}
      css={{ marginTop: withVar(SpacingToken.Spacing2) }}
    >
      HelpDesk Enterprise
    </Text>
    <Button
      size="compact"
      kind="primary"
      onClick={onCtaClick}
      data-testid="schedule-a-meeting"
      css={{ marginTop: withVar(SpacingToken.Spacing8) }}
    >
      Schedule meeting
    </Button>
  </Container>
);

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 11;
  padding: 0 ${withVar(SpacingToken.Spacing8)} 0 0;

  @media (max-width: ${ResponsiveBreakpoint.Tablet}px) {
    padding: 0 ${withVar(SpacingToken.Spacing8)} 0;
  }
`;
